import { openLink } from '../services/api/dialogService';

const ARCHIVE_CODE_IMPORT_ARCHIVE = 'Import archive';

export const openDocumentLink = (link: string, recno?: number, archiveCode?: string): void => {
    if (archiveCode === ARCHIVE_CODE_IMPORT_ARCHIVE) {
        openLink(`locator/DMS/Dialog/ConnectedDocumentDialog?recno=${recno}&SAVEAS=1&MoveTo=1&dialogFromAddin=true`);
        return;
    }

    openLink(`${link}&dialogFromAddin=true`);
};